import { Outlet } from 'react-router-dom';

import { Stack } from '@mui/material';

import { useLandingFlow } from '@/features/landingFlow';

import { ServerNotificationBanner } from '@/entities/user/currentUser';

import { Loader } from '@/shared/ui/Loader';
// eslint-disable-next-line boundaries/element-types
import { DesktopSidebar } from '../../../sidebar';
import { SContainer } from './styled';

export const MainLayout = () => {
  const { isLandingFlow } = useLandingFlow();

  if (isLandingFlow) return <Loader />;

  return (
    <SContainer>
      <DesktopSidebar />
      <Stack flex="1">
        <ServerNotificationBanner />
        <Outlet />
      </Stack>
    </SContainer>
  );
};
